export enum AccessibilityKeys {
  SortBy = "sort_by",
  ChooseSizeDropdownName = "choose_size_dropdown_name",
  ChooseSizeDropdownItemSelected = "choose_size_dropdown_item_selected",
  ChooseSizeDropdownNoSizeSelectedError = "choose_size_dropdown_no_size_selected_error",
  FilterChipOn = "filter_chip_on",
  FilterChipRemoved = "filter_chip_removed",
  FilterChipClearAll = "filter_chip_clear_all",
  StoreInfoText = "store_information",
  StockLevelTooltip = "pdp_stock_tooltip",
  StoreInfoDetailsLink = "store_details",
  StoreFacilities = "store_facilities",
}

export type AccessibilityLabels = {
  [key in AccessibilityKeys]?: string;
};
